// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { HashRouter as Router } from 'react-router-dom'

import MainScreen from './MainScreen';
import SplashScreen from './SplashScreen';
import PasswordResetScreen from './PasswordResetScreen';
import TwoFactorScreen from './TwoFactorScreen';
import PasswordChangeScreen from './PasswordChangeScreen';

import * as coreSelectors from './core/selectors';
import QuotePaymentScreen from './QuotePaymentScreen';
import MainLayout from 'ui/MainLayout';
import { withTheme } from '@material-ui/core/styles';
/*
 * Top level app component that sets theme 
 */

class AppComponent extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isMobile: false,
    }
    this.phoneButtonRef = React.createRef();
  }
  
  componentDidMount(){
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = ()=>{
    const { theme }  = this.props;
    if (window.innerWidth <= theme.breakpoints.values.md && !this.state.isMobile) {
      this.setState({
        isMobile:true
      })
    }
    else if(window.innerWidth > theme.breakpoints.values.md && this.state.isMobile){
      this.setState({
        isMobile: false
      })
    }
  }
  /*
   * Figure out which screen to show.  This implements all the
   * security flow.
   */
  getScreen = () => {
    const { user,
      loginState,
      showSplash,
      passwordChangeKey,
      passwordChangeKeyExpiration,
      manualPasswordChange,
      agentUserSession } = this.props;

    // if(window.location.href.includes('startQuote') && !window.location.href.includes('portalApi')) {
    //   window.location.href = window.location.href.replace('startQuote', 'portalApi/api/startQuoteV2');
    //   return;
    // }

    if (loginState === 'quotes') {
      return (<QuotePaymentScreen />);
    }

    /* No session reset password screen */
    if (loginState === 'reset') {
      return (<PasswordResetScreen />);
    }

    /* Show a blank or splash screen on startup.  The splash is only
       displayed just before redirecting to the B2C login page as there
       is sometimes takes a few seconds to load it */
    if (loginState !== 'active') {
      if (showSplash) {
        return (<SplashScreen />);
      } else {
        return (<div />);
      }
    }

    /* If it is a temporary password or the user has selected to change it
     * manually, present either the two factor screen or the password
     * screen depending on if we have a usable password change key */
    if ((user.temporaryPassword === 'Y' || manualPasswordChange) && !agentUserSession) {
      let now = new Date();
      if (passwordChangeKey.length === 0 ||
        passwordChangeKeyExpiration < now) {
        // return(<PasswordChangeScreen/>);
        return (<TwoFactorScreen />);
      } else {
        return (<PasswordChangeScreen />);
      }
    }

    /* If the user has mandatory two factor and the session has not
       been verified, bring up the two factor screen */
    if (user.twoFactor === 'Y' && user.sessionTwoFactor === 'N') {
      return (<TwoFactorScreen />);
    }

    /* Otherwise all security tasks are done so show the main screen */
    return (
      <Router>
        <MainLayout isMobile={this.state.isMobile} ref={this.phoneButtonRef}>
          <MainScreen isMobile={this.state.isMobile} phoneAnchorEl={this.phoneButtonRef} />
        </MainLayout>
      </Router>);
  }


  render() {
    return (
      <React.Fragment>
        {this.getScreen()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user: coreSelectors.getUser(state),
    loginState: coreSelectors.getLoginState(state),
    showSplash: coreSelectors.getShowSplash(state),
    passwordChangeKey: coreSelectors.getPasswordChangeKey(state),
    passwordChangeKeyExpiration: coreSelectors.getPasswordChangeKeyExpiration(state),
    manualPasswordChange: coreSelectors.getManualPasswordChange(state),
    agentUserSession: coreSelectors.getAgentUserSession(state),
  });
};

const mapDispatchToProps = {
};

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(AppComponent));

